import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { DASHBOARD_SECTION_TITLE_STYLE } from '../../constants/dashboardLayout';

/**
 * Shared uppercase section label for Operate dashboards.
 * Optional count (e.g. Open Positions (11)) and right-side controls.
 */
export default function DashboardSectionTitle({
  title,
  count,
  children,
  as: Tag = 'h2',
  style,
  marginBottom = 16,
}) {
  const { colors } = useTheme();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 12,
        marginBottom,
        ...style,
      }}
    >
      <Tag
        style={{
          ...DASHBOARD_SECTION_TITLE_STYLE,
          color: colors.textMuted,
          display: 'flex',
          alignItems: 'baseline',
          gap: 8,
        }}
      >
        {title}
        {count != null && count !== '' && (
          <span
            style={{
              fontWeight: 500,
              color: colors.textMuted,
              textTransform: 'none',
              letterSpacing: 0,
              opacity: 0.85,
            }}
          >
            ({count})
          </span>
        )}
      </Tag>
      {children && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
          {children}
        </div>
      )}
    </div>
  );
}
